export const OPERATORS_REQUEST_DISPATCH = (state) => {
  state.status = 'requested';
};

export const OPERATORS_REQUEST_SUCCESS = (state) => {
  state.status = 'success';
};

export const OPERATORS_REQUEST_ERROR = (state) => {
  state.status = 'error';
};

export const SAVE_LIST = (state, val) => {
  state.list = val;
}

export const ADD_MORE_OPERATORS = (state, val) => {
  state.more = [...state.more, ...val.clients];
}

export const CLEAR_MORE_OPERATORS = (state) => {
  state.more = [];
}
export const ALTER_CUSTOMER_STATUS = (state, val) => {
  let arr = state.list.clients;
  arr.map((list_item) => {
    if (list_item.id == val.client_id) {
      list_item.is_active = val.is_active;
    }
  })
  let arrMore = state.more;
  arrMore.map((list_item) => {
    if (list_item.id == val.client_id) {
      list_item.is_active = val.is_active;
    }
  })
  state.list.clients = arr;
  state.more = arrMore;
}